import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { createModuleAccessGuard } from '../module-access.guard';
import { UserService } from './user.service';

export const createAccessRightGuard = (accessRight: string): CanActivateFn => createModuleAccessGuard(() => {
	return inject(UserService)
		.has(accessRight);
});

